import React, { useEffect, useState } from 'react';

interface SuccessModalProps {
    isOpen: boolean;
    onConfirm: () => void;
}

const SuccessModal: React.FC<SuccessModalProps> = ({ isOpen, onConfirm }) => {
    const [particles, setParticles] = useState<{ id: number; left: string; color: string; size: string; duration: string; delay: string }[]>([]);

    useEffect(() => {
        if (isOpen) {
            // Vibrant colors compliant with pink theme but visible on white
            const colors = ['#ff006e', '#fb5607', '#ffbe0b', '#8338ec', '#3a86ff', '#ff006e'];
            const newParticles = Array.from({ length: 60 }).map((_, i) => ({
                id: i,
                left: `${Math.random() * 100}%`,
                color: colors[Math.floor(Math.random() * colors.length)],
                size: `${Math.random() * 15 + 10}px`,
                duration: `${Math.random() * 2 + 2}s`,
                delay: `${Math.random() * 0.5}s`
            }));
            setParticles(newParticles);
        }
    }, [isOpen]);

    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 z-[200] flex items-center justify-center p-4 bg-pink-100/30 backdrop-blur-sm animate-in fade-in duration-500">
            <div className="relative bg-white/95 backdrop-blur-xl rounded-[3rem] p-12 max-w-2xl w-full shadow-[0_20px_60px_rgba(255,100,100,0.3)] text-center transform animate-in zoom-in duration-500 border border-pink-100">

                {/* Visible Confetti Animation - Z-Index raised and overflow visible */}
                <div className="absolute inset-0 overflow-visible pointer-events-none">
                    {particles.map((p) => (
                        <div
                            key={p.id}
                            className="absolute animate-float"
                            style={{
                                left: p.left,
                                color: p.color,
                                fontSize: p.size,
                                animation: `confetti ${p.duration} linear forwards`,
                                animationDelay: p.delay,
                                top: '-50px',
                                zIndex: 50 // Ensure it's on top
                            }}
                        >
                            {Math.random() > 0.6 ? '❤️' : (Math.random() > 0.5 ? '✨' : '🎉')}
                        </div>
                    ))}
                </div>

                <div className="relative z-10">
                    <div className="text-7xl mb-8 animate-bounce scale-110">🥰</div>
                    <h2 className="text-3xl md:text-4xl font-black text-pink-600 mb-6 font-serif tracking-tight">
                        I Knew You'd Say Yes!
                    </h2>
                    <p className="text-pink-500/80 text-xl font-medium mb-10 leading-relaxed italic">
                        "You've just made me the happiest person in the entire world. I have something more to tell you..."
                    </p>

                    <button
                        onClick={onConfirm}
                        className="group relative px-10 py-4 bg-pink-500 hover:bg-pink-600 text-white text-xl font-bold rounded-full shadow-2xl transition-all duration-300 transform active:scale-95 z-50"
                    >
                        <span className="relative z-10">Yes, tell me! ❤️</span>
                        <div className="absolute inset-0 rounded-full bg-white/20 blur-md scale-0 group-hover:scale-100 transition-transform duration-300" />
                    </button>
                </div>
            </div>
        </div>
    );
};

export default SuccessModal;
